<template>
  <RedesignWebccRadioGroup
    v-model="model"
    class="grid gap-4"
    :aria-busy="loading ? 'true' : undefined"
  >
    <template v-if="loading">
      <div :class="GRID_CLASSES">
        <RedesignWebccRadio
          v-for="(width, index) in loadingOptions"
          :id="`${name}-${index}`"
          :key="`item-${index}`"
          class="animate-pulse"
          :checked="false"
          :value="''"
          disabled
        >
          <slot name="item.loader" :idx="index">
            <RedesignTextLoading :style="{ width: `${width / 16}rem` }" />
          </slot>
        </RedesignWebccRadio>
      </div>
    </template>

    <template v-else>
      <div :class="GRID_CLASSES">
        <RedesignWebccRadio :checked="!model" :value="undefined">
          {{ $t('www.common.any') }}
        </RedesignWebccRadio>

        <RedesignWebccRadio
          v-for="option in options"
          :id="`${name}-${option.value}`"
          :key="`${option.value}`"
          :checked="option.value === model"
          :value="option.value"
        >
          <slot name="item" :option="option" />
        </RedesignWebccRadio>
      </div>
    </template>
  </RedesignWebccRadioGroup>
</template>

<script
  setup
  lang="ts"
  generic="
    TValue extends string | number | undefined,
    TOption extends FilterOption<TValue>
  "
>
const LOADING_COUNT = 4
const GRID_CLASSES = 'grid grid-cols-1 gap-y-4 sm:grid-cols-3 md:grid-cols-1'

defineSlots<{
  item(props: { option: TOption }): any
  ['item.loader'](props: { idx: number }): any
}>()

const props = withDefaults(
  defineProps<{
    name: string
    loading?: boolean
    loadingItems?: number
    options?: TOption[]
  }>(),
  {
    loadingItems: LOADING_COUNT,
    options: () => [],
  },
)

const model = defineModel<TValue>({
  required: true,
  default: () => undefined,
}) as Ref<TValue>

const loadingOptions = computed(() =>
  Array.from({ length: props.loadingItems }, () => 40 + Math.random() * 100),
)
</script>
